import CSS from "./static/css/ProductRequestEdit.module.css";
import { useNavigate, useSearchParams } from "react-router-dom";
import { MouseEvent, useEffect, useMemo, useRef, useState } from "react";
import { ProductDetail_OptionListEle_Interface, ProductDetail_SelectedOptionListEle_Interface, ProductDetail_SelectInformationDate_Address_Interface } from "./static/interface/ProductDetail.interface";
import { callAxios, customParseInt, customToast, dateObjectManagerClass, dev_console, getAccountData, getQueryParamsUrl, imageUploadManagerClass2, isAbleAccesser, isSuccess, printStateMsg } from "../../Common/ts/commonTools";
import useProductDetailSetting from "./hooks/useProductDetailSetting";
import useProductDetailREST from "./hooks/REST/useProductDetailREST";
import { defaultApiReaponseInterface, uploadRequestfileDataInterface } from "../../Common/interface/Common.interface";
import { toast } from "react-toastify";
import { addedInfoDataInterface, satisfiedPhotoNumsInterface, uploadImgFilesInterface } from "./static/interface/ProductRequestEdit.interface";
import LoopAnimationModal from "../../Component/Elements/LoopAnimationModal/LoopAnimationModal";
import { userDataStorageManagerClass } from "./static/ts/common.tools";
import { albumDataInterface } from "./static/interface/common.interface";
import { PRODUCT_STATE_CODE_OBJ } from "./static/ts/const";
import ThreeSplitPages from "../../Component/Elements/Page/ThreeSplitPages/ThreeSplitPages";
import SplitPagesContainer from "../../Component/Elements/Page/ThreeSplitPages/components/SplitPagesContainer/SplitPagesContainer";
import UploadImageList from "./components/UploadImageList/UploadImageList";
import FolderList from "./components/FolderList/FolderList";
import OptionList from "./components/OptionList/OptionList";
import ProductInfoCard from "./components/ProductInfoCard/ProductInfoCard";
import AdditionalInfoContainer from "./components/AdditionalInfoContainer/AdditionalInfoContainer";
import AddressInfoCard from "./components/AddressInfoCard/AddressInfoCard";
import SubmitBtnContainer from "./components/SubmitBtnContainer/SubmitBtnContainer";
import PageChangeTabMenu from "./components/PageChangeTabMenu/PageChangeTabMenu";
import BlurEmptyBlock from "../../Component/Elements/BlurEmptyBlock/BlurEmptyBlock";
import ApplicationNoteMessage from "./components/ApplicationNoteMessage/ApplicationNoteMessage";
import AddAddressBtn from "./components/AddAddressBtn/AddAddressBtn";
import { addressListManagerClass } from "./static/ts/common.tools";
import { RTN_interface } from "../../Common/interface/App.interface";
import MainInfoCardTitle from "../../Component/Elements/MainInfoCard/components/MainInfoCardTitle/MainInfoCardTitle";
import { useCommonStore } from "../../App";
import { useGlobalInputFocus } from "../../Common/hooks/useGlobalInputFocus";
import useIsMobile from "../../Common/hooks/useIsMobile";
import usePhotoImageDataListREST from "./hooks/REST/usePhotoImageDataListREST";
import { FILE_USAGE_CD } from "./static/interface/ProductItemPhoto.interface";
import { backPointUrlManagerClass } from "../../Common/ts/appTools";

// 기존
// const imageUploadManager = new imageUploadManagerClass();
const backPointUrlManager = new backPointUrlManagerClass();

// 신규
const imageUploadManager2 = new imageUploadManagerClass2();

const addressListManager = new addressListManagerClass();

const userDataStorageManager = new userDataStorageManagerClass();

const { customFormatDate } = new dateObjectManagerClass();

const TOAST_ID = "ProductRequestEdit";

const ProductRequestEdit = () => {
    const [isUploading, setIsUploading] = useState<boolean>(false);

    // 컴포넌트 숨김
    const [isHidedenComponent, setIsHidedenComponent] = useState<boolean>(false);

    // 모바일환경에서 탭메뉴 페이지 번호
    const [pageNum, setPageNum] = useState<number>(1);

    //  업로드된 이미지 데이터(key값은 folder의 id로 처리한다)
    const [imgFiles, setImgFiles] = useState<uploadImgFilesInterface>({});

    //  각 폴더별로 업로드된 사진의 개수가 만족하는지 여부
    const [satisfiedPhotoNums, setSatisfiedPhotoNums] = useState<satisfiedPhotoNumsInterface>({});

    //  새로 선택한 옵션들
    const [selectedOptionList, setSelectedOptionList] = useState<ProductDetail_SelectedOptionListEle_Interface[]>([]);

    // 추가입력정보(앨범에서 입력받는 아기정보)
    const [newAddedInfo, setNewAddedInfo] = useState<addedInfoDataInterface>({
        baby_name: "",
        baby_birth: null,
        baby_birth_time: null,
        tall: "",
        weight: "",
    })

    const leftContainerEleRefList = useRef<Array<HTMLDivElement | null>>([]);
    const centerContainerEleRefList = useRef<Array<HTMLDivElement | null>>([]);

    const setHeaderRightNode = useCommonStore((state) => state.setHeaderRightNode);

    // 편집 요청 내용
    const [request, setRequest] = useState<string>("");

    const navigate = useNavigate();

    const [URLSearchParamsData, SetURLSearchParamsData] = useSearchParams();

    let l_is_done = URLSearchParamsData.get("is_done");

    let l_contract_product_id = customParseInt(URLSearchParamsData.get("contract_product_id"));
    // album_save_id는 고객이 사진을 업로드하면 생성된다.
    let l_album_save_id = customParseInt(URLSearchParamsData.get("album_save_id"));
    // photo_upload_id는 편집 사진이 업로드되면 생성된다.
    let l_photo_upload_id = customParseInt(URLSearchParamsData.get("photo_upload_id"));

    // 제품제작 신청이 완료된 직후에 다음 페이지에서 뒤로가기버튼을 통해 이 페이지에 접근한경우엔 productList로 내보낸다.
    // 뒤로가기 버튼을 통해 이미 완료된 해당페이지로 재진입하는것을 방지
    if(l_is_done === "Y"){
        window.location.href = "/productList";
    }

    // album_save_id와 photo_upload_id는 항상 있는 필수값이 아니므로 contract_product_id값이 넘어오는지만 확인한다.
    // l_contract_product_id가 없다면 처리가 불가능하므로 내보낸다.
    if(!l_contract_product_id){
        window.location.href = "/productList";
    }

    // 위의 null조건을 통과한 후에는 무조건 값이 있는 상태이다. -> 자료형을 교정해준다.
    l_contract_product_id = l_contract_product_id as number;

    // 전역으로 input이나 textarea에 포커스가 있는지 확인하는 훅
    const isInputFocused = useGlobalInputFocus();

    const {
        productDetailData,
    } = useProductDetailREST({
        contract_product_id: l_contract_product_id,
        album_save_id: l_album_save_id,
        photo_upload_id: l_photo_upload_id
    })

    const {
        productDetailInfoData,
        productOptionDataList,
        folderList,
        initialSelectOptionDataList,
        addedInfo,
        isAlbum,
        productQty,
        totalAddressQty,
        tempAddressList,
        setTempAddressList,
    } = useProductDetailSetting({
        productDetailData,
    })

    // 이미 업로드된 이미지가 있는지 조회
    const {
        photoImageDataListData,
        photoImageDataListError,
        photoImageDataListIsLoading,
        photoImageDataListRefetch,
    } = usePhotoImageDataListREST({
        brand_id: productDetailInfoData?.brand_id || 0,
        data_pk: productDetailInfoData?.contract_product_id || 0,
        file_usage_cd: FILE_USAGE_CD.CUSTOMER_SELECTED_PHOTO,
    })

    // // 폴더 이미지 데이터 요청
    // const {
    //     photoImageDataListData: folderImageDataListData,
    //     photoImageDataListIsLoading: folderImageDataListIsLoading,
    //     photoImageDataListError: folderImageDataListError,
    //     photoImageDataListRefetch: folderImageDataListRefetch,
    // } = usePhotoImageDataListREST({
    //     brand_id: productDetailData?.product_detail_data?.brand_id || 0,
    //     data_pk: productDetailInfoData?.detail_product_id || 0,
    //     file_usage_cd: FILE_USAGE_CD.PRODUCT_FOLDER,
    // })

    // // 옵션 이미지 데이터 요청
    // const {
    //     photoImageDataListData: optionImageDataListData,
    //     photoImageDataListIsLoading: optionImageDataListIsLoading,
    //     photoImageDataListError: optionImageDataListError,
    //     photoImageDataListRefetch: optionImageDataListRefetch,
    // } = usePhotoImageDataListREST({
    //     brand_id: productDetailData?.product_detail_data?.brand_id || 0,
    //     data_pk: productDetailInfoData?.detail_product_id || 0,
    //     file_usage_cd: FILE_USAGE_CD.PRODUCT_OPTION,
    // })

    // // 폴더의 이미지 주소를 새로운 주소로 업데이트
    // const newImageFolderDataList = useMemo(() => {
    //     const uploadFileDetailData = folderImageDataListData?.data?.[0]?.upload_file_detail_data;

    //     if(!uploadFileDetailData){
    //         return folderList;
    //     }

    //     const RTN = folderList.map((folder) => {
    //         const m_image = uploadFileDetailData.find((image) => `${image.folder_id}` == `${folder.folder_id}`);

    //         return {
    //             ...folder,
    //             middle_img_url: m_image?.middle_img || "",
    //             small_img_url: m_image?.small_img || "",
    //         }
    //     })

    //     return RTN;
    // }, [folderImageDataListData, folderList]);

    const l_isMobile = useIsMobile();

    const pageNumBtnClickHandler = (pageNum: number) => {
        setPageNum(pageNum);
    }

    // dpi 최소값
    const min_resolution = useMemo(() => {
        let RTN: number = 0;

        if(productDetailInfoData){
            RTN = customParseInt(productDetailInfoData.min_resolution) || 0;
        }

        return RTN;
    }, [productDetailInfoData]);

    // 최소 긴쪽 픽셀값
    const min_long_size = useMemo(() => {
        let RTN: number = 0;

        if(productDetailInfoData){
            RTN = customParseInt(productDetailInfoData.min_long_size) || 0;
        }

        return RTN;
    }, [productDetailInfoData]);

    // 최소 짧은쪽 픽셀값
    const min_short_size = useMemo(() => {
        let RTN: number = 0;

        if(productDetailInfoData){
            RTN = customParseInt(productDetailInfoData.min_short_size) || 0;
        }

        return RTN;
    }, [productDetailInfoData]);

    // 옵션 추가 핸들러
    const addOptionItemHandler = (option: ProductDetail_SelectedOptionListEle_Interface) => {
        // 현재는 선택할 수 있는 옵션이 반드시 1개이므로 선택한 옵션으로 그냥 갱신시킨다.
        setSelectedOptionList([option]);
    }

    // 옵션 제거 핸들러
    const subOptionItemHandler = (option: ProductDetail_SelectedOptionListEle_Interface) => {
        if(!window.confirm(`선택하신 ${option.option_name} 옵션을 제거하시겠습니까?`)){
            return ;
        }

        setSelectedOptionList((prev) => prev.filter((item) => item.option_id !== option.option_id));
    }

    // 옵션 선택 클릭 동작은 최종적으로 토글방식을 사용하게 하자..
    const selectOptionItemClickHandler = (option: ProductDetail_SelectedOptionListEle_Interface) => {
        if(selectedOptionList.includes(option)){
            subOptionItemHandler(option);
        }else{
            addOptionItemHandler(option);
        }
    }

    // 스크롤 액션 함수
    const scrollToFirstFalseItem = (folder_id: number) => {
        const m_ele_current = centerContainerEleRefList.current[folder_id];
        if (m_ele_current) {
            // 스크롤 이동
            m_ele_current.scrollIntoView({
                behavior: "smooth",
                block: "start",
            });
        }
    };

    // 취소버튼은 뒤로가기...
    const cancelHandler = () => {
        if(!window.confirm("작성하신 내용이 모두 사라집니다.\n\n정말 취소하시겠습니까?")){
            return ;
        }

        let m_url: string = "/productList";

        // album_save_id가 존재한다는 이야기는, 기존에 업로드한 이미지가 존재한는 뜻이다 -> 재업로드를 위해 페이지를 이동했던 상태이므로 제품 상세페이지로 이동시킨다.
        if(l_album_save_id){
            const m_productDetail_url = getQueryParamsUrl({
                main_url: "/productDetail",
                queryParams: {
                    contract_product_id: `${l_contract_product_id || ""}`,
                    album_save_id: `${l_album_save_id || ""}`,
                    photo_upload_id: `${l_photo_upload_id || ""}`,
                }
            })

            m_url = m_productDetail_url;
        }

        navigate(m_url)
    }

    // 미완료된 항목이 있는지 검증하는 함수
    const checkFalseValue = () => {
        // 객체의 key-value 쌍을 배열로 변환
        const entries = Object.entries(satisfiedPhotoNums);

        // 가장 먼저 감지된 value가 false인 key 찾기
        const firstFalseKey = entries.find(([key, value]) => value === false);

        if (firstFalseKey) {
            const [key] = firstFalseKey;
            return parseInt(key); // 필요에 따라 key 값을 반환
        } else {
            return null; // false 값이 없으면 null 반환
        }
    };

    const addressInfoChecker = (address: ProductDetail_SelectInformationDate_Address_Interface) => {
        const RTN: RTN_interface<boolean> = {
            sign: false,
            data: false,
            msg: "",
        }

        dev_console.log(address);
        dev_console.log(address);
        dev_console.log(address);

        Check:{
            if(!address.recipient_name){
                RTN.msg = "받는이 이름을 입력해 주세요.";
                break Check;
            }

            if(!address.recipient_phone){
                RTN.msg = "받는이 휴대폰을 입력해 주세요.";
                break Check;
            }

            if(!address.addr || !address.zip_code){
                RTN.msg = "주소를 입력해 주세요.";
                break Check;
            }

            RTN.sign = true;
            RTN.data = true;
        }

        return RTN;
    }

    const addressChecker = () => {
        const RTN: RTN_interface<boolean> = {
            sign: false,
            data: false,
            msg: "",
        }

        const m_remain_qty = productQty - totalAddressQty;

        Check:{
            // 배송지 정보 자체가 존재하지 않음.
            if(totalAddressQty < 1){
                RTN.msg = "배송지를 추가해 주세요.";
                break Check;
            }

            // 제대로 입력되지 않은 부분이 있음.
            for(const address of tempAddressList){
                const m_address_checker = addressInfoChecker(address);
                if(!m_address_checker.sign){
                    RTN.msg = m_address_checker.msg;
                    break Check;
                }
            }

            if(totalAddressQty >= productQty){
                RTN.sign = true;
                RTN.data = true;
                RTN.msg = "배송지 정보가 모두 입력되었습니다.";
                break Check;
            }

            if(window.confirm(`${m_remain_qty}개의 물품에 대한 배송지가 입력되지 않았습니다.\n\n남은 물품은 첫 번째 배송지로 설정하시겠습니까?`)){
                const m_first_address = {...tempAddressList[0]};
                m_first_address.product_qty = m_first_address.product_qty + m_remain_qty;
                addressListManager.editAddress({
                    address_list: tempAddressList,
                    data: m_first_address,
                    index: 0,
                    addressListSetter: setTempAddressList,
                })

                RTN.sign = true;
                RTN.data = true;
                RTN.msg = "배송지 정보가 모두 입력되었습니다.";
                break Check;
            }

            RTN.msg = `${m_remain_qty}개의 물품에 대한 배송지를 설정해 주세요.`;
        }

        if(!RTN.sign){
            dev_console.log(RTN.msg);
        }

        return RTN;
    }

    // 서버에 업로드 요청
    const requesetSelectHandler = async () => {
        let check_result = checkFalseValue();

        if(check_result !== null){
            dev_console.error("check_result");
            dev_console.error(check_result);

            if(check_result > 0){
                customToast.error({
                    msg: "필요한 수만큼 사진이 선택되지 않은 항목이 있습니다.",
                    toastId: TOAST_ID
                });
                scrollToFirstFalseItem(check_result);
            }else{
                customToast.error({
                    msg: "필요한 수만큼 사진이 선택되지 않았습니다.",
                    toastId: TOAST_ID
                });
            }

            return ;
        }

        if(productOptionDataList.length> 0 && selectedOptionList.length === 0){
            customToast.error({
                msg: "옵션을 선택해 주세요.(필수 택 1)",
                toastId: TOAST_ID
            });

            scrollToFirstFalseItem(-1);

            return ;
        }

        // 배송지정보가 입력되었는지 검토할 필요가 있음...
        // 그 방법을 검토해보자.
        const m_address_check = addressChecker();
        if(!m_address_check.sign){
            customToast.error({
                msg: m_address_check.msg,
                toastId: TOAST_ID
            });

            return ;
        }

        if(!window.confirm("상품 제작을 위한 사진을 모두 선택하셨습니까?\n\n제품 제작이 시작되면 입력하신 내용과 선택하신 사진 변경이 불가능합니다.")){
            return ;
        }else if(!window.confirm(`사진 선택을 완료하시겠습니까?`)){
            return ;
        }

        // 로딩처리 시작
        setIsUploading(true);

        const file_data: uploadRequestfileDataInterface[] = [];

        let master_file_url = `media/office/${productDetailInfoData?.office_id || ""}/customers/${productDetailInfoData?.customer_id || ""}/selectPhoto/contract/${productDetailInfoData?.contract_id || ""}/products/${productDetailInfoData?.contract_product_id || ""}`;

        if(folderList.length > 0 && folderList[0].folder_id > 0){
            master_file_url += "/folder";
        }
        // if(newImageFolderDataList.length > 0 && newImageFolderDataList[0].folder_id > 0){
        //     master_file_url += "/folder";
        // }

        // 업로드중에 이상이 없었는지 확인하는 변수
        let m_upload_complet_sign: boolean = true;


        // 기존 이미지가 있는가?
        let isHaveFile = false;
        FileCheck:{
            if(!photoImageDataListData){
                break FileCheck;
            }

            if(!photoImageDataListData.data){
                break FileCheck;
            }

            if(photoImageDataListData.data.length === 0){
                break FileCheck;
            }

            isHaveFile = true;
        }

        // 기존 이미지가 있는경우 제거하고 진행하도록 컨펌 진행
        if(isHaveFile){
            if(!window.confirm("기존 이미지를 제거하고 재업로드 하시겠습니까?")){
                setIsUploading(false);
                return ;
            }

            const m_file_data_clear = await imageUploadManager2.FileDataClear({
                brand_id: productDetailInfoData?.brand_id || 0,
                file_usage_cd: Number(FILE_USAGE_CD.CUSTOMER_SELECTED_PHOTO),
                data_pk: productDetailInfoData?.contract_product_id || 0,
                is_all_clear: 1,
            });

            if(!m_file_data_clear.isContinue){
                customToast.error({
                    msg: m_file_data_clear.message,
                    toastId: TOAST_ID
                });
                setIsUploading(false);
                return ;
            }
        }


        let baby_birth:string = "";
        if(newAddedInfo.baby_birth){
            baby_birth = customFormatDate(newAddedInfo.baby_birth, "yyyy-MM-dd");
        }

        let birth_time: string = "";
        if(newAddedInfo.baby_birth_time){
            birth_time = customFormatDate(newAddedInfo.baby_birth_time, "HH:mm");
        }

        const m_baby_birth_date_time = new Date(`${baby_birth} ${birth_time}`);
        const m_babyinfo: albumDataInterface = {
            baby_name: newAddedInfo.baby_name,
            baby_birth: m_baby_birth_date_time,
            baby_birth_time: m_baby_birth_date_time,
            tall: newAddedInfo.tall,
            weight: newAddedInfo.weight,
        }

        // dev_console.log(config);

        // 입력한 받는이 정보를 스토리지에 저장
        // 요청을 성공한 후에 저장해도 좋지만, 실패했을경우에는 더더욱 반복해서 입력해야하니까 미리 저장하는게 좋지 않을까? 해서 여기서 저장
        userDataStorageManager.babyInfo.set(m_babyinfo);

        const config = {
            contract_product_id: productDetailInfoData?.contract_product_id,
            contract_id: `${productDetailInfoData?.contract_id}`,
            office_id: productDetailInfoData?.office_id,
            album_save_id: `${l_album_save_id || ""}`,// album_save_id가 unll이 아니라는 이야기는 고객이 이미 최초 사진 업로드를 했다는 이야기다.
            // thema_id_list: selectedOptionList.map((item) => item.option_id).join(","),

            /** 선택한 옵션 */
            theme_id: selectedOptionList.map((item) => item.option_id).join(","),
            baby_name: newAddedInfo.baby_name,
            baby_birth,
            birth_time,
            height: newAddedInfo.tall,
            weight: newAddedInfo.weight,
            common_memo: request,
            master_file_url: master_file_url,
            file_data: file_data,
            addr_list: tempAddressList,
        }

        let final_album_save_id: number | null = l_album_save_id;

        try{
            const check_result = await imageUploadManager2.FileUploadR2GarbageCheck({
                log_in_staff_id: getAccountData.user_id(),
                brand_id: productDetailInfoData?.brand_id || 0,
                file_usage_cd: Number(FILE_USAGE_CD.CUSTOMER_SELECTED_PHOTO),
                data_pk: productDetailInfoData?.contract_product_id || 0,
            });

            if(!check_result.isContinue){
                throw new Error(check_result.message);
            }

            const m_file_list: File[][] = [];
            const m_folder_id_list: number[] = [];

            folderList.forEach((item) => {
                m_file_list.push(imgFiles[item.folder_id]);
                m_folder_id_list.push(item.folder_id);
            });
            // newImageFolderDataList.forEach((item) => {
            //     m_file_list.push(imgFiles[item.folder_id]);
            //     m_folder_id_list.push(item.folder_id);
            // });

            const m_result = await imageUploadManager2.FileUploadR2Chunk(
                m_file_list,
                productDetailInfoData?.brand_id || 0,
                {
                    file_usage_cd: 2,
                    data_pk: productDetailInfoData?.contract_product_id || 0,
                    upload_file_pk: 0,
                    is_allow_overlap: 1,
                    add_data: config,
                },
                {
                    onProgress: () => {},
                    onAbort: () => {},
                },
                m_folder_id_list,
            )

            dev_console.log("m_result ============");
            dev_console.log(m_result);
            dev_console.log("================================================");

            final_album_save_id = m_result.album_save_id || null;
        }catch(error: any){
            dev_console.error(error);

            // 에러로 인한 로딩 종료
            setIsUploading(false);

            customToast.error({
                msg: error.message,
            })

            m_upload_complet_sign = false;
        }

        // 업로드중 오류가 발생했다면, 하위 동작을 진행하지 않는다.
        if(!m_upload_complet_sign){
            return ;
        }

        // 로딩 종료
        setIsUploading(false);
        toast.dismiss(TOAST_ID);

        // // 페이지 이동
        // const m_productDetail_url = getQueryParamsUrl({
        //     main_url: "/productDetail",
        //     queryParams: {
        //         status_cd: `${PRODUCT_STATE_CODE_OBJ.application_in_progress || ""}`,
        //         contract_product_id: `${l_contract_product_id || ""}`,
        //         album_save_id: `${final_album_save_id || ""}`,
        //         photo_upload_id: `${l_photo_upload_id || ""}`,
        //         is_done: "Y",
        //     }
        // })

        // 페이지 이동
        const m_productDetail_url = getQueryParamsUrl({
            main_url: "/productDetail",
            queryParams: {
                contract_product_id: `${l_contract_product_id || ""}`,
                album_save_id: `${final_album_save_id || ""}`,
                photo_upload_id: `${l_photo_upload_id || ""}`,
                is_done: "Y",
                back_point: backPointUrlManager.encoded({url: `/productList?tab1=0`}),
            }
        })

        navigate(m_productDetail_url);
    };

    // 신규 주소를 추가하하는 핸들러 함수
    const addEmptyAddressHandler = (event: MouseEvent<HTMLButtonElement>) => {
        event.stopPropagation();

        addressListManager.addNewAddress({
            address_list: tempAddressList,
            data: {
                recipient_name: "",
                recipient_phone: "",
                zip_code: "",
                addr: "",
                building_no: "",
                addr_detail: "",
                product_qty: 1,
            },
            addressListSetter: setTempAddressList,
        })
    }

    useEffect(() => {
        isAbleAccesser({
            allowedUserTypeList: ["C"]
        })

        setHeaderRightNode(<></>);
    }, [])

    // 기존에 선택한 옵션 선택정보를 업데이트한다.
    useEffect(() => {
        setSelectedOptionList(initialSelectOptionDataList);
    }, [initialSelectOptionDataList])

    // 기존에 설정한 추가정보를 업데이트한다.
    useEffect(() => {
        if(addedInfo){
            const m_birthDatetime = new Date(addedInfo.baby_birth_day);
            const m_birthTimeDatetime = new Date(`${addedInfo.baby_birth_day} ${addedInfo.baby_birth_day}`);

            setNewAddedInfo({
                baby_name: addedInfo.baby_name,
                baby_birth: isNaN(m_birthDatetime.getTime()) ? null : m_birthDatetime,
                baby_birth_time: isNaN(m_birthTimeDatetime.getTime()) ? null : m_birthTimeDatetime,
                tall: addedInfo.baby_height,
                weight: addedInfo.baby_weight,
            })

            setRequest(addedInfo.common_memo);
        }else{
            const m_babyInfo = userDataStorageManager.babyInfo.get();
            if(m_babyInfo){
                setNewAddedInfo(m_babyInfo);
            }
        }
    }, [addedInfo])

    // input이나 textarea에 포커스가 있을경우 컴포넌트 숨김을 활성화
    useEffect(() => {
        if(l_isMobile){
            if(isInputFocused){
                setIsHidedenComponent(true);
            }else{
                setIsHidedenComponent(false);
            }
        }
    }, [isInputFocused]);

    return(
        <ThreeSplitPages
            title=""
            is_navi_hidden={true}
            background_color={"select_page"}

            headerContainerNode={
                l_isMobile
                &&
                    <div className={CSS.l_ProductRequestEdit_headerContainer}>
                        {
                            !isHidedenComponent
                            &&  <ApplicationNoteMessage />
                        }
                        <PageChangeTabMenu
                            pageNum={pageNum}
                            isHaveOption={productOptionDataList.length > 0}
                            clickHandler={pageNumBtnClickHandler}
                        />
                    </div>
            }

            // pageNum값이 1이 아니면 모바일환경에서만 숨겨지는 스타일을 적용시킨다 === 웹환경에서는 pageNum에 상관없이 항상 보이고, 모바일 환경에서만 pageNum에따라 숨겨진다.
            isLeftHidden={pageNum !== 1 ? "mobile" : undefined}
            leftContainerNode={
                <SplitPagesContainer>
                    {
                        !l_isMobile
                        &&  <FolderList
                                folder_list={folderList}
                                ele_refs={leftContainerEleRefList}
                                is_have_options={productOptionDataList.length > 0}
                                eleClickHandler={scrollToFirstFalseItem}
                            />
                    }
                    {
                        (l_isMobile && pageNum === 1)
                        &&   <UploadImageList
                                folderList={folderList}
                                imgFiles={imgFiles}
                                setImgFiles={setImgFiles}
                                isSatisfiedPhotoNums={satisfiedPhotoNums}
                                setIsSatisfiedPhotoNums={setSatisfiedPhotoNums}
                                min_resolution={min_resolution}
                                min_long_size={min_long_size}
                                min_short_size={min_short_size}
                            />
                    }

                    {
                        !l_isMobile
                        &&  <BlurEmptyBlock location="bottom" />
                    }

                    {
                        !l_isMobile
                        &&  <ApplicationNoteMessage />
                    }
                </SplitPagesContainer>
            }

            isCenterHidden={pageNum !== 2 ? "mobile" : undefined}
            centerContainerNode={
                <SplitPagesContainer>
                    {
                        !l_isMobile
                        &&  <UploadImageList
                                folderList={folderList}
                                imgFiles={imgFiles}
                                setImgFiles={setImgFiles}
                                isSatisfiedPhotoNums={satisfiedPhotoNums}
                                setIsSatisfiedPhotoNums={setSatisfiedPhotoNums}
                                cardRefs={centerContainerEleRefList}
                                min_resolution={min_resolution}
                                min_long_size={min_long_size}
                                min_short_size={min_short_size}
                            />
                    }

                    {
                        (!l_isMobile || pageNum === 2)
                        &&  <OptionList
                                productOptionDataList={productOptionDataList}
                                selectedOptionList={selectedOptionList}
                                itemOnClickHandler={selectOptionItemClickHandler}
                                cardRefs={centerContainerEleRefList}
                            />
                    }

                    {
                        !l_isMobile
                        &&  <BlurEmptyBlock location="bottom"/>
                    }
                </SplitPagesContainer>
            }

            isRightHidden={pageNum !== 3 ? "mobile" : undefined}
            rightContainerNode={
                <SplitPagesContainer>
                    {
                        !l_isMobile
                        &&  <div className={CSS.l_ProductRequestEdit_ProductInfoCardContainer}>
                                <ProductInfoCard
                                    product_name={
                                        productDetailInfoData?.product_name
                                        ?   <div className={CSS.l_ProductRequestEdit_titleContainer}>
                                                <MainInfoCardTitle text={productDetailInfoData.product_name}/>
                                                <MainInfoCardTitle text={`${productDetailInfoData.product_qty}개`} style={"highlight"}/>
                                            </div>
                                        :   ""
                                    }
                                    is_has_options={productOptionDataList.length > 0}
                                    selectedOptionData={selectedOptionList}
                                    subOptionItemHandler={subOptionItemHandler}
                                />
                            </div>
                    }

                    {
                        (!l_isMobile || pageNum === 3)
                        &&  <>
                                <AdditionalInfoContainer
                                    addedInfo={newAddedInfo}
                                    setAddedInfo={setNewAddedInfo}
                                    request={request}
                                    setRequest={setRequest}
                                    isAlbum={isAlbum}
                                />

                                <AddressInfoCard
                                    addressList={tempAddressList}
                                    setAddressList={setTempAddressList}
                                    productQty={productQty}
                                    totalAddressQty={totalAddressQty}
                                />

                                <AddAddressBtn
                                    addEmptyAddressHandler={addEmptyAddressHandler}
                                    is_visible={productQty > totalAddressQty}
                                />
                            </>
                    }

                    {
                        !l_isMobile
                        &&  <SubmitBtnContainer
                                cancelBtnHandler={cancelHandler}
                                selectBtnHandler={requesetSelectHandler}
                            />
                    }
                </SplitPagesContainer>
            }

            bottomContainerNode={
                <>
                    {
                        l_isMobile && !isHidedenComponent
                        &&  <SubmitBtnContainer
                                cancelBtnHandler={cancelHandler}
                                selectBtnHandler={requesetSelectHandler}
                            />
                    }

                    <LoopAnimationModal isModalOpen={isUploading} />
                </>
            }
        />
    )
}

export default ProductRequestEdit;